import OtherTypesConfig from '@/config/other-types'
import luhn from '@/mixins/luhn_algorithm'

export default function luhnAlgorithm (value) {
	return value.length === OtherTypesConfig.CREDIT_CARD_NUMBER_LENGTH && luhn(value)
}